<template>
  <div class="modal-coupon-code-input-parts">
    <div class="modal-coupon-code-input-parts__input">
      <fieldset-text-parts
        v-model="text"
        :label="$tc('common.flowLineToPaidPlan.discount.code')"
        :placeholder="$tc('common.flowLineToPaidPlan.discount.placeholder')"
        :showError="hasError"
        :errorMessage="errorMessage"
      />
    </div>
    <div class="modal-coupon-code-input-parts__submit">
      <atom-button :linkText="buttonLabel" @onClick="handleUseClicked" />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import FieldsetTextParts from '@/components/common/form/FieldsetTextParts.vue'
import AtomButton from '@/components/atoms/AtomButton.vue'

export default defineComponent({
  name: 'ModalCouponCodeInputParts',
  components: { AtomButton, FieldsetTextParts },
  props: {
    value: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      required: true,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    /**
     * text
     * @param {string} val
     */
    const text = computed({
      get: () => props.value,
      set: (val: string) => emit('input', val),
    })

    const handleUseClicked = () => {
      emit('onCLickUse')
    }

    return {
      text,
      handleUseClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.modal-coupon-code-input-parts {
  &__input {
    padding-top: 12px;
    margin-top: 24px;

    ::v-deep {
      .label-text {
        color: #808080;
      }

      [type='text']:not(.input--validation-error) {
        color: $black;
      }

      .form-error-message-parts {
        white-space: pre-line;
      }
    }
  }

  &__submit {
    margin-top: 8px;
  }
}
</style>
